import React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import '../../styles/scss/components/equote-preview-package-ship-details.scss'
import { getBrandClassName } from '../../reducers/packageDetails'
import { getShipImages, getShipVideo } from '../../reducers/ships'

import EQuotePackageCarousel from '../carousel/EQuotePackageCarousel'
import { getSingleBrandDetails } from '../../reducers/brands'
import { filterImagesByFileName } from '../../utils/filterImagesByFileName'
import VirtualTourArrowButton from '../elements/VirtualTourArrowButton'
import ShipSpecs from './ShipSpecs'

const EQuotePreviewPackageShipDetails = props => {
  const virtualTourLink = get(props, 'shipDetails.virtual_tour_button_link')
  const virtualTourButtonText = get(
    props,
    'shipDetails.virtual_tour_button_text'
  )

  if (!props.shipDetails) {
    return (
      <p className="u-text-center">Ship information unavailable at this time</p>
    )
  }

  return (
    <div className="u-content-container">
      <div className="equote-preview-package-ship-details" id="ship">
        <h1 className={`section-title ${props.brandClassName}`}>
          Ship Information{' '}
          <small>{props.shipDetails && props.shipDetails.name}</small>
        </h1>

        <div className="content">
          {/*  LEFT IS CAROUSEL + DESCRIPTION */}
          <div className="left">
            <EQuotePackageCarousel
              shouldHideText
              slides={props.slides || []}
              sliderName="Ship details slider"
              shouldSendGaEvent
              gaNextArrowText="ship-details-slider-next"
              gaPrevArrowText="ship-details-slider-prev"
            />
            {props.shipDetails && props.shipDetails.body && (
              <div className={`ship-description`}>
                <p
                  dangerouslySetInnerHTML={{ __html: props.shipDetails.body }}
                />
              </div>
            )}
            <ShipSpecs shipDetails={props.shipDetails} useToggle />
          </div>
          <div className="right">
            {props.shipDetails && <ShipSpecs shipDetails={props.shipDetails} />}
            {virtualTourLink && virtualTourLink.length > 0 ? (
              <div className="virtual-tour-container">
                <VirtualTourArrowButton
                  text={virtualTourButtonText || 'Virtual Tour'}
                  onClick={() =>
                    props.openVirtualTourModal({
                      link: virtualTourLink,
                      title: virtualTourButtonText || 'Virtual Tour'
                    })
                  }
                  brandClassName={props.brandClassName}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const shipImages = getShipImages(state, 4, 'ship-details')
  const shipVideo = getShipVideo(state)

  const brandImage = getSingleBrandDetails(state)
    ? getSingleBrandDetails(state).image
    : []
  const slides = shipImages.length
    ? filterImagesByFileName(shipImages, 'details-hero')
    : filterImagesByFileName(brandImage, 'details-hero')
  return {
    shipDetails: state.ships.shipDetails ? state.ships.shipDetails : null,
    brandClassName: getBrandClassName(state),
    slides: shipVideo
      ? [{ type: 'video', file: shipVideo }, ...(slides || [])]
      : slides
  }
}

export default connect(mapStateToProps)(EQuotePreviewPackageShipDetails)
